import React from 'react'

const Financial = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="59"
      height="59"
      viewBox="0 0 59 59"
    >
      <g>
        <g>
          <path
            fill="#46cbf9"
            d="M0 5a5 5 0 0 1 5-5h49a5 5 0 0 1 5 5v49a5 5 0 0 1-5 5H5a5 5 0 0 1-5-5z"
          />
        </g>
        <g>
          <g>
            <path
              fill="#fff"
              d="M32.951 47.222a.982.982 0 0 1-.59.198H7.56a.986.986 0 0 1-.788-1.58l2.008-2.687a.792.792 0 0 0 .157-.474V30.038c0-6.11 4.936-11.062 11.023-11.062 6.088 0 11.023 4.953 11.023 11.062v12.641c0 .171.055.338.157.474l2.008 2.687a.99.99 0 0 1-.197 1.382zM15.467 12.136l.21-.14a2.474 2.474 0 0 1 2.477-.158c1.141.57 2.483.57 3.624 0a2.468 2.468 0 0 1 2.477.158l.21.14-2.696 5.405c-.597-.092-1.2-.14-1.804-.145-.604.005-1.206.053-1.803.145zM34.418 44.89l-1.85-2.475V30.038c-.01-5.663-3.77-10.63-9.205-12.161l2.825-5.658a.791.791 0 0 0-.268-1.01l-.788-.529a4.049 4.049 0 0 0-4.057-.252 2.471 2.471 0 0 1-2.21 0 4.049 4.049 0 0 0-4.057.252l-.788.528a.791.791 0 0 0-.268 1.01l2.82 5.659c-5.437 1.528-9.199 6.496-9.209 12.16v12.38l-1.85 2.475a2.573 2.573 0 0 0 .511 3.594c.443.334.982.514 1.536.514h24.81c1.414 0 2.56-1.15 2.56-2.568 0-.555-.18-1.096-.512-1.54z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M47.463 31.548v1.586h-1.567v-1.586H44.33v1.586h-1.567v-1.586h-1.566v1.586H39.63v-3.173h10.966v3.173h-1.567v-1.586zm3.133 7.934v3.184h-1.567v-1.592h-1.566v1.592h-1.567v-1.592H44.33v1.592h-1.567v-1.592h-1.566v1.592H39.63v-3.184zm0 7.944h-1.567v-1.592h-1.566v1.592h-1.567v-1.592H44.33v1.592h-1.567v-1.592h-1.566v1.592H39.63v-3.184h10.966zM38.062 36.313v1.592h-1.565v-3.184h10.956v3.184h-1.565v-1.592h-1.565v1.592h-1.566v-1.592h-1.565v1.592h-1.565v-1.592zm-1.565-7.94V25.2h10.956v3.174h-1.565v-1.587h-1.565v1.587h-1.566v-1.587h-1.565v1.587h-1.565v-1.587h-1.565v1.587zm0-10.319c0-3.064 2.452-5.549 5.478-5.549 3.025 0 5.478 2.485 5.478 5.55 0 3.064-2.453 5.548-5.478 5.548-3.024-.003-5.475-2.485-5.478-5.549zm14.882 16.667a.788.788 0 0 0 .784-.793v-4.76a.788.788 0 0 0-.784-.794h-2.35v-3.967a.788.788 0 0 0-.783-.794h-1.845c3.032-2.473 3.512-6.968 1.07-10.04a6.989 6.989 0 0 0-9.912-1.084c-3.033 2.473-3.512 6.968-1.07 10.04.317.4.676.763 1.07 1.084h-1.845a.788.788 0 0 0-.784.794v4.76c0 .439.351.794.784.794h2.35v3.173h-2.35a.788.788 0 0 0-.784.794v4.76c0 .439.351.794.784.794h2.35v8.728c0 .438.35.793.783.793h12.532a.788.788 0 0 0 .784-.793v-9.522a.788.788 0 0 0-.784-.793h-2.35v-3.174z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M37.65 18.165h1.814a2.72 2.72 0 0 1 2.72-2.721V13.63a4.54 4.54 0 0 0-4.534 4.535z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M44.91 17.26a2.72 2.72 0 0 1-2.72 2.72v1.815a4.54 4.54 0 0 0 4.535-4.535z"
            />
          </g>
          <g>
            <path
              fill="#fff"
              d="M24.043 31.167v-.155c-.002-1.694-1.393-3.068-3.109-3.07h-.156V26.33h-1.633v1.612h-.157c-1.716.004-3.105 1.382-3.1 3.077a3.077 3.077 0 0 0 2.346 2.97l3.058.754c.792.192 1.276.981 1.082 1.763a1.472 1.472 0 0 1-1.44 1.11h-1.946a1.468 1.468 0 0 1-1.475-1.457v-.155H15.88v.155c.002 1.695 1.392 3.068 3.108 3.07h.157v1.613h1.633v-1.613h.156c1.717-.004 3.106-1.381 3.102-3.077a3.077 3.077 0 0 0-2.347-2.97l-3.058-.754a1.457 1.457 0 0 1-1.082-1.763 1.472 1.472 0 0 1 1.44-1.11h1.945c.815 0 1.475.653 1.476 1.457v.155h1.633z"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default Financial
